import script from "./submit.vue?vue&type=script&setup=true&lang=js"
export * from "./submit.vue?vue&type=script&setup=true&lang=js"

import "./submit.vue?vue&type=style&index=0&id=2be1680c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2be1680c"]])

export default __exports__